import {setup, run} from '../../snippets/go';
import comment from '../../snippets/comment';
import {CreateShellCommand} from '../../../components/left-col';

export const steps = {
  setup,
  create: {},
  'payment-methods': {},
  'line-items': {},
  mode: {},
  redirect: {},
  urls: {},
  'run-server': {
    Component: CreateShellCommand(run),
  },
};

export default ({
  keys,
  merchant,
  client,
  demo: {paymentMethods},
  activePrice,
  checkoutMode,
}) => `package main

import (
    "log"
    "net/http"
    {+setup}
    "github.com/stripe/stripe-go/v72"
    "github.com/stripe/stripe-go/v72/checkout/session"
    {/setup}
)

func main() {
  ${comment && comment(merchant)}
  stripe.Key = "${keys.secret}"

  http.Handle("/", http.FileServer(http.Dir("public")))
  http.HandleFunc("/create-checkout-session", createCheckoutSession)
  addr := "localhost:4242"
  log.Printf("Listening on %s", addr)
  log.Fatal(http.ListenAndServe(addr, nil))
}

func createCheckoutSession(w http.ResponseWriter, r *http.Request) {
  domain := "${
    client === 'react'
      ? 'http://localhost:3000/checkout'
      : 'http://localhost:4242'
  }"
  {+create}
  params := &stripe.CheckoutSessionParams{
    {?customize prefill-email}
    CustomerEmail: stripe.String("customer@example.com"),
    {/prefill-email}
    {?customize submit-button}
    SubmitType: stripe.String("donate"),
    {/submit-button}
    {?customize address}
    BillingAddressCollection: stripe.String("auto"),
    ShippingAddressCollection: &stripe.CheckoutSessionShippingAddressCollectionParams{
      AllowedCountries: stripe.StringSlice([]string{
        "US",
        "CA",
      }),
    },
    {/address}
    {+line-items}
    LineItems: []*stripe.CheckoutSessionLineItemParams{
      &stripe.CheckoutSessionLineItemParams{
        ${
          activePrice
            ? `Price: stripe.String("${activePrice.id}")`
            : `// TODO: replace this with the \`price\` of the product you want to sell
        Price: stripe.String("{{PRICE_ID}}")`
        },
        Quantity: stripe.Int64(1),
      },
    },
    {/line-items}
    {+payment-methods}
    PaymentMethodTypes: stripe.StringSlice([]string{
      ${
        paymentMethods.length
          ? paymentMethods.map((key) => `"${key}",`).join('\n      ')
          : '// TODO: pass at least one option here'
      }
    }),
    {/payment-methods}
    {+mode}
    Mode: stripe.String(string(stripe.CheckoutSessionMode${checkoutMode
      .charAt(0)
      .toUpperCase() + checkoutMode.slice(1)})),
    {/mode}
    {+urls}
    SuccessURL: stripe.String(domain + "${
      client === 'react' ? '?success=true' : '/success.html'
    }"),
    CancelURL: stripe.String(domain + "${
      client === 'react' ? '?canceled=true' : '/cancel.html'
    }"),
    {/urls}
    {?automatic-tax automatic-tax-param}
    AutomaticTax: &stripe.CheckoutSessionAutomaticTaxParams{Enabled: stripe.Bool(true)},
    {/automatic-tax-param}
  }

  {span response create}s{/span}, err := session.New(params)

  if err != nil {
    log.Printf("session.New: %v", err)
  }

{/create}
  {+redirect}
  http.Redirect(w, r, s.URL, http.StatusSeeOther)
  {/redirect}
}`;
